import { render, staticRenderFns } from "./vitransfer.vue?vue&type=template&id=ae4b68e4&scoped=true"
import script from "./vitransfer.vue?vue&type=script&lang=js"
export * from "./vitransfer.vue?vue&type=script&lang=js"
import style0 from "./vitransfer.vue?vue&type=style&index=0&id=ae4b68e4&prod&lang=css"
import style1 from "./vitransfer.vue?vue&type=style&index=1&id=ae4b68e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4b68e4",
  null
  
)

export default component.exports